/**
 * OrderDetailMixin
 */

export const OrderDetailMixin = {
  name: 'OrderDetailMixin',

  data: () => {
    return {};
  },

  methods: {
    gotoOrder(order) {
      let tradeType = '';
      if (!order.isPresellTrade) {
        tradeType = 'normal';
      } else {
        if (0 === order.preSellType) {
          tradeType = 'presell';
        } else if (1 === order.preSellType) {
          tradeType = 'lockprice';
        }
        tradeType = tradeType + '-';
        if (0 === order.preSellStatus) {
          tradeType = tradeType + 'deposit';
        } else if (1 === order.preSellStatus) {
          tradeType = tradeType + 'balance';
        }
      }
      this.$router.push(`/trade/${tradeType}/${order.i_myOrderId}`);
    },
  },
};

export default OrderDetailMixin;
